import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { filter, take, tap } from 'rxjs';
import { OAuthEvent, OAuthService, OAuthSuccessEvent } from 'angular-oauth2-oidc';

@Component({
  selector: 'login',
  template: ''
})
export class LoginComponent implements OnInit {
  router = inject(Router);
  oAuthService = inject(OAuthService);

  ngOnInit() {
    if (this.oAuthService.hasValidAccessToken()) this.redirect();
    else {
      this.oAuthService.events
        .pipe(
          filter((event: OAuthEvent) => event instanceof OAuthSuccessEvent && event.type === 'token_received'),
          tap(() => setTimeout(() => this.redirect())) // TODO: Check this hack
        )
        .subscribe();
    }
  }

  redirect() {
    const prevStateStored = localStorage.getItem('gs1-ecli-previous-state');

    if (prevStateStored) {
      const prevState = JSON.parse(prevStateStored);
      localStorage.removeItem('gs1-ecli-previous-state');
      this.router.navigateByUrl(prevState.url, { replaceUrl: true });
    } else this.router.navigateByUrl('/', { replaceUrl: true });
  }
}
